import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Listingheader from '../../../../home/components/common/ListingheaderV2';
import HeaderTab from '../../../../home/components/desktop/HeaderTabV2/HeaderTab';
import PointsTable from '../PointsTable/PointsTable';
import PointsTableList from '../PointsTable/PointsTableList';
import s from './PointsTableWrapper.scss';
import InterSectionBorder from '../../../../../components_v2/common/InterSectionBorder/InterSectionBorder';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

const PointsTableWrapper = props => {
  const {
    name = '',
    bordertop = '',
    borderbottom = '',
    hideTabs = '',
    className = '',
    hideFlags = '',
    isFifaPage = '',
    headerHeading,
    items = {},
    imageLogo,
    imageLink,
    id,
    ga4Category,
    ga4Type,
  } =
    props.sectionItem || {};
  const standings = items?.standings;
  const isMlc = !!(id === 'points_table_MLC');
  console.log('items in wrapper', items?.series?.name);
  const isIplPointsTable =
    items?.series?.name &&
    typeof items?.series?.name === 'string' &&
    (items?.series?.name.toLowerCase().includes('indian premier league') ||
      items?.series?.name.toLowerCase().includes('sa20 league, 2025/26'));
  // eslint-disable-next-line no-shadow
  const setHeaderGroupTabs = standings => {
    if (standings === null || typeof standings === 'undefined') {
      return {};
    }
    const headerVal = Object.keys(
      standings && typeof standings === 'object' ? standings : {},
    ).filter(tab => {
      const stage = standings[tab];
      return stage && Array.isArray(stage.groups) && stage.groups.length > 0;
    });
    let tableGroupData;
    let headerTabData;
    if (headerVal.length > 0) {
      headerTabData = headerVal.map((tab, idx) => {
        let tabObj = {
          id: idx,
          name:
            standings[tab] && standings[tab]?.stage_type
              ? standings[tab]?.stage_type
              : tab,
          // link: tab === 'stage1' ? ' ' : tab,
          link: tab,
        };
        if (
          standings[tab]?.is_active &&
          standings[tab].is_active.toLowerCase() === 'true'
        ) {
          tabObj = {
            active: !!(
              standings[tab]?.is_active &&
              standings[tab].is_active.toLowerCase() === 'true'
            ),
            ...tabObj,
          };
          tableGroupData = standings[tab];
        }
        return tabObj;
      });
    }
    return { headerTabData, tableGroupData };
  };
  const { headerTabData, tableGroupData } = setHeaderGroupTabs(standings);
  const [pointTableData, setPointTableData] = useState(standings);
  const [headerTab, setHeaderTab] = useState(headerTabData);
  const [groupData, setGroupData] = useState(tableGroupData);
  const [selectedTab, setSelectedTab] = useState();
  const [teamData, setTeamData] = useState([]);

  // eslint-disable-next-line no-shadow
  const recievePointTableData = standings => {
    setPointTableData(standings);
    const { tabData, grpData } = setHeaderGroupTabs(standings);
    setGroupData(grpData);
    setHeaderTab(tabData);
  };

  useEffect(
    () => {
      if (
        groupData &&
        Object.keys(groupData).length > 0 &&
        groupData.groups &&
        Array.isArray(groupData.groups) &&
        groupData.groups.length > 0
      ) {
        const groupTeam = groupData.groups.filter(
          val => val.name === selectedTab,
        );
        setTeamData(groupTeam[0]);
      }
    },
    [selectedTab],
  );

  useEffect(
    () => {
      if (
        props?.ifFifaHomePageWidget &&
        props?.FifaData &&
        Object.keys(props?.FifaData).length > 0
      ) {
        recievePointTableData(props?.FifaData);
        if (props?.currentTab === 'Points Table') {
          setSelectedTab('A');
        } else {
          setSelectedTab('Group A');
        }
      }
      const element = document.getElementById(selectedTab);
      if (element) {
        element.scrollIntoView({ block: 'nearest', Inline: 'center' });
      }
    },
    [props?.FifaData],
  );
  const isDataActiveHtml = () => {
    if (props?.isPointsTablePage) {
      return (
        <div className={s.white_bg_wrapper}>
          <div className={s.emptyCard}>
            <div className={s.emptyCardContent}>
              <figure>
                <img
                  src="https://static.toiimg.com/photo/108620037.cms"
                  alt="ball wicket shape"
                />
              </figure>
              <span>No Data Available</span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const onHeaderTabsChange = dataObj => {
    if (
      dataObj?.clickedItem &&
      dataObj?.clickedItem?.link &&
      pointTableData &&
      pointTableData[dataObj.clickedItem.link]
    ) {
      setGroupData(pointTableData[dataObj.clickedItem.link]);
    }
  };

  const groupDataList =
    isFifaPage && items?.standings && items?.standings?.stage1
      ? items?.standings?.stage1
      : groupData;
  return typeof tableGroupData === 'object' &&
    Object.keys(tableGroupData).length > 0 ? (
    <>
      {!!bordertop && <InterSectionBorder />}
      {!props?.ifFifaHomePageWidget && (
        <div className={`${s.section_wrapper} ${className}`}>
          {!isFifaPage && (
            <Listingheader
              headingname={name}
              data={
                imageLink && imageLogo
                  ? {
                      sponsoredLink: imageLink,
                      sponsoredLogomsid: imageLogo,
                      sponsoredTxt: 'POWERED BY',
                      sponsoredClass: 'sponsored_logo',
                      isMlcPage: isMlc,
                    }
                  : {}
              }
              ga4Category={ga4Category}
              ga4Type={ga4Type}
            >
              {headerTab &&
                headerTab instanceof Array && (
                  <HeaderTab
                    subSections={headerTab}
                    onChangeCallback={onHeaderTabsChange}
                    // loading={this.state.loading}
                    // active={sectionData && sectionData.id === 'elections' && this.tabName}
                    // newga={`${sectionData.name}Section_TabChange#Click_`}
                  />
                )}
            </Listingheader>
          )}

          {groupDataList &&
            groupDataList?.groups &&
            Array.isArray(groupDataList?.groups) &&
            groupDataList?.groups.length > 0 && (
              <PointsTable
                groupData={groupDataList?.groups}
                hideTabs={hideTabs}
                hideFlags={hideFlags}
                isFifaPage={isFifaPage}
                currentTab={groupDataList?.groups[0]?.name}
                isWapView={props?.isWapView}
                headerHeading={headerHeading}
                isIplPointsTable={isIplPointsTable}
                isMlc={isMlc}
              />
            )}
          {groupDataList?.team &&
            Array.isArray(groupDataList?.team) && (
              <PointsTableList
                tabData={groupDataList}
                hideFlags={hideFlags}
                isFifaPage={isFifaPage}
                activeTab=""
                className={s.activeTab}
                isWapView={props.isWapView}
                headerHeading={headerHeading}
                isIplPointsTable={isIplPointsTable}
              />
            )}
        </div>
      )}
      {props?.ifFifaHomePageWidget && (
        <>
          <>
            <div className={`${s.fifaTab} fifaTab`}>
              {groupData &&
                groupData.groups &&
                Array.isArray(groupData.groups) &&
                groupData.groups.length > 0 &&
                groupData.groups.map((val, index) => (
                  <div
                    className={`${s.tabLink} ${
                      val.name === selectedTab ? s.active : ''
                    }`}
                    key={index}
                    onClick={() => setSelectedTab(val.name)}
                    id={selectedTab}
                  >
                    {props?.currentTab === 'Points Table' ? 'GROUP' : ''}{' '}
                    {val.name}
                  </div>
                ))}
            </div>
          </>
          <div className={`${s.tableWrapper} tableWrapper`}>
            <PointsTableList
              tabData={teamData}
              hideFlags={hideFlags}
              isFifaPage={props?.isFifaPage}
              activeTab=""
              className={s.activeTab}
              isWapView={props?.isWapView}
              headerHeading={props?.headerHeading}
              ifFifaHomePageWidget
              currentTab={props?.currentTab}
              isIplPointsTable={isIplPointsTable}
            />
          </div>
        </>
      )}
      {!!borderbottom && <InterSectionBorder />}
    </>
  ) : (
    isDataActiveHtml()
  );
};

PointsTable.propTypes = {
  sectionItem: PropTypes.objectOf({}),
  isWapView: PropTypes.bool,
  hideTabs: PropTypes.string,
  hideFlags: PropTypes.string,
  isFifaPage: PropTypes.string,
  headerHeading: PropTypes.arrayOf({}),
  ifFifaHomePageWidget: PropTypes.bool,
  FifaData: PropTypes.objectOf({}),
  fifaData: PropTypes.arrayOf({}),
  currentTab: PropTypes.string,
  isPointsTablePage: PropTypes.bool,
};
PointsTable.defaultProps = {
  sectionItem: {},
  isWapView: false,
  hideTabs: '',
  hideFlags: '',
  isFifaPage: '',
  headerHeading: [],
  ifFifaHomePageWidget: false,
  FifaData: {},
  fifaData: [],
  currentTab: '',
  isPointsTablePage: false,
};

export default React.memo(PointsTableWrapper);
